import * as types from './mutation-types'


export const loadTasks = ({commit}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('tasks/collections').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
 
export const getProjectTasks = ({commit}, data) => {
    let query = data.filter
    return new Promise((resolve, reject) => {
        window.axios.get('tasks/'+data.id+'/details', {
            params: {
                search: query?.search,
                project_category_step_id: query?.milestone,
                task_priority_id: query?.priority,
            }
        }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getTask = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('tasks/'+id+'/details/view').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const createTask = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('tasks/store', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateTask = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.put('tasks/' + data.id + '/update', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateTaskAssignUser = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post(`tasks/assign/task/${data.task_id}/users`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeTaskStatut = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.post('tasks/change/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeMultipleTaskStatut = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('tasks/multiple/change/status', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const changeStatutPosition = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.put('update/project/category/step/status/position', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const changeTaskPosition = ({commit}, data) => {

    return new Promise((resolve, reject) => {
        window.axios.put(`tasks/shift/position`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteTask = ({commit}, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete('tasks/'+id+'/delete').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const validateTask = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`tasks/validate`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const rejectTask = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`tasks/reject`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

